/* eslint-disable spire/export-styles */
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import Link from "@insite/mobius/Link";
import * as React from "react";

type Props = HasProductContext;

const ProductReplacementProductLink: React.FC<Props> = ({
    productContext: {
        product,
        productInfo: { qtyOrdered, unitOfMeasure, inventory },
    },
}) => {
    return (
        <div style={{ display: "block", paddingBottom: "10px", paddingLeft: "5px" }}>
            {product &&
                product.replacementProductNumber &&
                product.replacementProductNumber.length !== 0 &&
                typeof product.replacementProductNumber === "number" && (
                    <label className="radio" style={{ display: "inline-block", fontWeight: "bold" }}>
                        {translate("Replacement Products")}
                        <span style={{ paddingRight: "8px", display: "inline-block" }}>:</span>
                    </label>
                )}
            {product &&
                product.replacementProductNumber &&
                product.replacementProductNumber.length !== 0 &&
                typeof product.replacementProductNumber === "number" && (
                    <Link
                        data-test-selector="cdtReplacementProductLink"
                        href={`/Catalog/${product.replacementProductNumber}`}
                    >
                        {`${product.replacementProductNumber}`}
                    </Link>
                )}
        </div>
    );
};

const productReplacementProductLink: WidgetModule = {
    component: withProductContext(ProductReplacementProductLink),
    definition: {
        group: "Products",
        allowedContexts: [ProductDetailsPageContext],
    },
};

export default productReplacementProductLink;
